import { useMemo } from 'react'

import { createStore, Provider } from './store'

/**
 * Is a HOC that initializes the store specifically for EmbedFeed widget
 * and delivers it via a context provider.
 */
export const EmbedFeedStoreProvider: React.FunctionComponent<
  React.PropsWithChildren
> = ({ children }) => {
  const store = useMemo(() => createStore(), [])

  return <Provider store={store}>{children}</Provider>
}
